import { ErrorContainer } from 'components/organisms/Error/ErrorContainer';
import React from 'react';
import { useQuery } from '@apollo/client';
import { QUERY_SOFT_SKILLS } from '../../../../graphql/query/note/softSkills.query';
import { useRefetchData } from '../../../../helpers/refetch/refetchData';
import { LoadingContainer } from 'components/molecules/Loaders/LoadingContainer';
import FrontError from '../../../../helpers/errors/front.error';
import { QuerySoftSkillsQuery } from '../../../../graphql/generated/graphql';
import { FeatureMyClassView } from './FeatureMyClass.view';
import { commissionCalcul } from '../../../../domain/commission/commission';
import { getUserPerfsFromQuery } from '../../../../helpers/transformApiResponse/user';
import { ClasseRank } from '../../../../types/classe/classeRank';
import { useSelector } from 'react-redux';
import { getUserClasse } from 'store/selectors/user/user.selectors';

export const FeatureMyClass = () => {
  const { data, loading, error, refetch } = useQuery<QuerySoftSkillsQuery>(
    QUERY_SOFT_SKILLS
  );
  useRefetchData(refetch);
  const classeInfos = useSelector(getUserClasse);
  if (loading) return <LoadingContainer variant="MyClass" />;
  if (error)
    return (
      <ErrorContainer
        detailErr={
          new FrontError(
            'Récupération des perfs commerciales / compétences',
            error
          )
        }
        text={
          "Veuillez recharger l'affichage des performances commerciales et compétences"
        }
        setFeedback
      />
    );

  const user = getUserPerfsFromQuery(data?.getUserSoftSkills);
  const resultCommissionCalcul = commissionCalcul(
    user.classe.note.qteca,
    user.classe.users.filter(u => u.role.id !== process.env.REACT_APP_PROF_ID)
  );
  const rank = data?.getClassePosition as ClasseRank;

  return (
    <FeatureMyClassView
      rank={rank}
      amountCommission={resultCommissionCalcul.commission}
      percentOfCommission={resultCommissionCalcul.taux}
      classe={classeInfos.name}
    />
  );
};
